import Axios from 'axios';
import Collection from '@/stores/abstract/Collection';
import Model from '@/stores/abstract/Model';
import axiosInstance from '@/helpers/axios';
import {generateLog} from '@/helpers/functions';
const CancelToken: any = Axios.CancelToken;
let cancel: any;
const URL: string = '/contact/module';

export class ContactModule extends Model<IContactModule> implements IContactModule {

  id!: number | null;
  active!: boolean;
  name!: string;
  sort!: number | null;
  countryCode!: string;
  moduleId!: number | null;
  itemId!: number | null;
  // @ts-ignore
  number: number | null;

  constructor(attributes: any = {}, parentCollection?: any) {
    super(
      {
        ...{
          id: null,
          active: '',
          countryCode: '',
          name: '',
          sort: '',
          moduleId: '',
          itemId: '',
        }, ...attributes,
      }, // Default values
      parentCollection,
    );
  }
  URL(): string {
    return URL;
  }

  urlRoot(): string {
    return '';
  }
}

export default class ContactModuleCollection extends Collection<ContactModule> {

  routeName = 'contactModule';

  model(): Constructor<ContactModule> {
    return ContactModule;
  }

  url(): string {
    return URL;
  }

  URL(): string {
    return URL;
  }

  fetchData(index: number | null, search: string | null, perPage: number | 10) {
    if (cancel !== undefined) {
      cancel();
    }

    if (index === null) {
      index = 1;
    }

    let url = this.URL() + '?page=' + index + '&perpage=' + perPage;
    if (search) {
      url = url + '&search=' + search;
    }

    return axiosInstance.get(url, {
      cancelToken: new CancelToken(function executor(c: any) {
        cancel = c;
      }),
    })
      .then((response) => response.data.data).catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }

  getDetail(contactId: any) {
    return axiosInstance.get(`${this.URL()}/${contactId}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }

  createNewItem(item: any) {
    return axiosInstance.post(`${this.URL()}`, item)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }

  updateItem(id: number, data: any) {
    return axiosInstance.put(`${this.URL()}/${id}`, data)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }

  deleteItem(id: number) {
    return axiosInstance.delete(`${this.URL()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }

  deleteItems(ids: any[]) {
    return axiosInstance.post(`${this.URL()}/delete`, {ids})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }
}
